import { TypedDocumentNode } from '@apollo/client'
import { useQuery } from '@apollo/client/react'
import { AdminPracticeBaseProvidersQueryDocument } from '@docpace/admin-graphql/dist/urql.types'
import { AdminPracticeBaseProvidersQueryResultFragment, AdminPracticeBaseProvidersQueryParams } from '@docpace/admin-graphql'

const typedAdminPracticeBaseProvidersQueryDocument = AdminPracticeBaseProvidersQueryDocument as TypedDocumentNode<AdminPracticeBaseProvidersQueryResultFragment, Partial<AdminPracticeBaseProvidersQueryParams>>

export function useAdminPracticeBaseProvidersQuery(opts?: useQuery.Options<AdminPracticeBaseProvidersQueryResultFragment, Partial<AdminPracticeBaseProvidersQueryParams>>){
    return useQuery(typedAdminPracticeBaseProvidersQueryDocument, opts)
}
